import { Directive, Input, TemplateRef } from '@angular/core';
var ValueInputTemplateDirective = (function () {
    function ValueInputTemplateDirective(template) {
        this.template = template;
    }
    return ValueInputTemplateDirective;
}());
export { ValueInputTemplateDirective };
ValueInputTemplateDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ngx-query-value-input-template]'
            },] },
];
/** @nocollapse */
ValueInputTemplateDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
ValueInputTemplateDirective.propDecorators = {
    'dataType': [{ type: Input },],
};
//# sourceMappingURL=value-input-template.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/directives/value-input-template.directive.js
// module id = null
// module chunks = 